const C = class Dropdown {
	static select = $context => $context.select('.dropdown');

	leave_timeout_id = null;

	constructor($dropdown) {
		this.$dropdown = $dropdown;

		this.bindGlobalEvents();
		this.bindEvents();

		return () => {
			this.destroyGlobalEvents();
		};
	}

	get is_enabled() {
		const is_mobile_disabled = this.$dropdown.hasClass('dropdown_mobile-disabled');
		if (is_mobile_disabled && ResponsiveUtil.isToTablet()) {
			return;
		}

		return true;
	}

	bindGlobalEvents() {
		$(document).on('click', this.handleDocumentClick);
	}

	destroyGlobalEvents() {
		$(document).off('click', this.handleDocumentClick);
	}

	bindEvents() {
		this.$dropdown.on('mouseenter', () => {
			if (!this.is_enabled) {
				return;
			}

			clearTimeout(this.leave_timeout_id);
			this.open();
		});

		this.$dropdown.on('mouseleave', () => {
			if (!this.is_enabled) {
				return;
			}

			this.leave_timeout_id = setTimeout(() => {
				this.close();
			}, 500);
		});

		this.$dropdown.find('.dropdown__dropdown').cssAnimation('dropdown__dropdown_animated');
	}

	handleDocumentClick = e => {
		if (!this.is_enabled) {
			return;
		}

		if ($(e.target).closest(this.$dropdown).length === 0) {
			clearTimeout(this.leave_timeout_id);
			this.close();
		}
	};

	isOpen() {
		return this.$dropdown.hasClass('dropdown_open');
	}

	open() {
		if (this.isOpen()) {
			return;
		}

		this.$dropdown.addClass('dropdown_open');
		this.$dropdown.find('.dropdown__dropdown').runCssAnimation('dropdown__dropdown_open-animation');
		this.$dropdown.trigger('open');
	}

	close() {
		if (!this.isOpen()) {
			return;
		}

		this.$dropdown.removeClass('dropdown_open');
		this.$dropdown.find('.dropdown__dropdown').runCssAnimation('dropdown__dropdown_close-animation');
		this.$dropdown.trigger('close');
	}
};

export default () => Component(C.select, $component => new C($component));
